export const personalInfo = {
  name: "Sparsh Jaiswal",
  title: "Senior Mobile Engineer",
  subtitle: "Production-Grade App Architect",
  bio: "Senior Flutter Developer with 4+ years of experience architecting and scaling production-grade mobile applications. Specialized in clean architecture, performance optimization, and delivering consumer apps that serve thousands of daily active users. I build mobile systems that scale.",
  email: "sparsh.jas07@gmail.com",
  phone: "+91 9971705484",
  location: "Ghaziabad, India",
  profileImage:
    "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/jha05nsg_sparsh5-Photoroom.jpg",
  resumeUrl:
    "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/05tw8ssn_resume.pdf",
  social: {
    linkedin: "https://www.linkedin.com/in/sparsh-jaiswal-240486154/",
    github: "https://github.com/Sparsh327",
    medium: "#",
  },
};

export const projects = [
  {
    id: "minglewise",
    name: "Minglewise",
    tagline: "Real-Time Dating at Scale",
    description:
      "A feature-rich dating application with real-time chat, video calling, and matchmaking algorithms serving 100K+ users.",
    downloads: "100K+",
    rating: "4.4",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.appsynergies.minglewise",
    appStoreUrl:
      "https://apps.apple.com/in/app/minglewise-dating-pro-events/id1574084760",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/qx1xb21s_minglewise.gif",
    techStack: ["Flutter", "WebRTC", "Socket.IO", "Firebase", "BLoC"],
    problem:
      "Building stable real-time communication for thousands of concurrent users.",
    solution:
      "Engineered WebRTC-based video calling and Socket.IO chat with low latency and high reliability.",
    impact: [
      "100K+ downloads",
      "5K+ daily active users",
      "<100ms average chat latency",
    ],
    architecture: {
      overview: "Event-driven architecture with real-time communication layer",
      layers: [
        "UI Layer",
        "Communication Layer",
        "State Management",
        "Backend Services",
      ],
      scalability: "Load-balanced WebRTC servers, horizontal scaling for chat",
      performance: "Optimized media streaming, efficient state updates",
    },
    challenges: [
      {
        title: "WebRTC Connection Stability",
        description:
          "Maintaining video calls across varying network conditions",
        solution: "Implemented TURN servers and adaptive bitrate streaming",
      },
      {
        title: "Real-Time State Synchronization",
        description: "Keeping chat and user status in sync across devices",
        solution: "Event sourcing pattern with optimistic UI updates",
      },
    ],
    screenshots: [
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
    ],
  },
  {
    id: "property-dictionary",
    name: "Property Dictionary",
    tagline: "Solving Fragmented Real Estate Discovery",
    description:
      "A comprehensive real estate marketplace enabling location-based property discovery with verified listings and complete admin management system.",
    downloads: "10K+",
    rating: "4.5",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.sararealtors.propertydictionary&pcampaignid=web_share",
    appStoreUrl:
      "https://apps.apple.com/in/app/property-dictionary/id6502470819",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/zinlg7bq_pd.gif",
    heroImage:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/e4uyr0a4_property-dictionary.png",
    techStack: [
      "Flutter",
      "Firebase",
      "Google Maps",
      "BLoC",
      "Clean Architecture",
    ],
    problem:
      "Real estate listings in Maharashtra were fragmented across multiple platforms, making property discovery inefficient for buyers and renters.",
    solution:
      "Built a unified platform with location-based search, verified listings, advanced filters, and a complete admin system for property management.",
    impact: [
      "10K+ downloads in first 6 months",
      "500+ daily active users",
      "80% user retention rate",
    ],
    architecture: {
      overview: "Feature-based Clean Architecture with BLoC state management",
      layers: [
        "Presentation Layer (UI + BLoC)",
        "Domain Layer (Use Cases + Entities)",
        "Data Layer (Repositories + Data Sources)",
      ],
      scalability:
        "Modular architecture allows independent feature development and testing",
      performance:
        "Lazy loading, image caching, and optimized map rendering for smooth UX",
    },
    challenges: [
      {
        title: "Location-Based Search Performance",
        description:
          "Optimized Firebase queries with geohashing for fast location-based searches",
        solution: "Implemented spatial indexing and query pagination",
      },
      {
        title: "Image Loading Performance",
        description: "Large property images caused slow loading times",
        solution:
          "Implemented progressive image loading with cached_network_image and CDN",
      },
    ],
    screenshots: [
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
    ],
  },
  {
    id: "chop-and-chicks",
    name: "Chop and Chicks",
    tagline: "Modernizing Meat Delivery",
    description:
      "A dual-app ecosystem for meat delivery with vendor management, consumer ordering, live delivery tracking, and push notifications.",
    downloads: "3K+",
    rating: "4.6",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.chopandchicks.consumer&hl=en",
    appStoreUrl: "https://apps.apple.com/in/app/chop-chicks/id6755097602",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/e77qpghx_WhatsAppVideo2026-03-14at5.46.38PM-ezgif.com-optimize.gif",
    heroImage:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/b3qyazuz_Screenshot%202026-03-14%20at%205.50.31%E2%80%AFPM.png",
    techStack: ["Flutter", "Firebase", "Google Maps", "FCM", "Provider"],
    problem:
      "Traditional meat delivery services lacked transparency and real-time tracking.",
    solution:
      "Built separate vendor and consumer apps with live tracking, automated notifications, and inventory management.",
    impact: [
      "3K+ orders per month",
      "98% on-time delivery rate",
      "4.6 average rating",
    ],
    architecture: {
      overview: "Dual-app architecture with shared business logic",
      layers: [
        "Consumer App",
        "Vendor App",
        "Shared Core Module",
        "Backend Services",
      ],
      scalability:
        "Shared packages for common features, independent deployment",
      performance: "Real-time location updates with optimized battery usage",
    },
    challenges: [
      {
        title: "Live Delivery Tracking",
        description:
          "Battery-efficient location tracking for delivery personnel",
        solution:
          "Implemented adaptive location updates based on delivery status",
      },
      {
        title: "Push Notification Reliability",
        description: "Ensuring critical order updates reach users",
        solution: "Multi-channel notification system with FCM + in-app alerts",
      },
    ],
    screenshots: [
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
    ],
  },
  {
    id: "ucall",
    name: "UCall",
    tagline: "Digital Discovery for Zambian Service Providers",
    description:
      "A comprehensive service marketplace connecting Zambian service providers with customers through geolocation, real-time chat, and automated scheduling.",
    downloads: "5K+",
    rating: "4.3",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.ucall.app",
    appStoreUrl: "https://apps.apple.com/in/app/ucall/id6743543001",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/9qhhm03o_Ucal.gif",
    techStack: ["Flutter", "Supabase", "WebRTC", "Socket.IO", "Riverpod"],
    problem:
      "Zambian service providers lacked a digital platform for customer discovery and booking management.",
    solution:
      "Created a dual-sided marketplace with geolocation search, real-time chat, automated scheduling, and end-to-end booking flow.",
    impact: [
      "5K+ active service providers",
      "15K+ bookings processed",
      "Average response time: <2 minutes",
    ],
    architecture: {
      overview: "MVVM architecture with Riverpod for state management",
      layers: ["UI Layer", "ViewModel Layer", "Repository Layer", "API Layer"],
      scalability: "Microservices backend with real-time event streaming",
      performance:
        "WebSocket connections for instant messaging, optimized database queries",
    },
    challenges: [
      {
        title: "Real-Time Chat Scalability",
        description: "Managing thousands of concurrent chat connections",
        solution:
          "Implemented Socket.IO with connection pooling and message queuing",
      },
      {
        title: "Offline-First Architecture",
        description: "Users in areas with poor connectivity",
        solution: "Built offline queue system with automatic sync when online",
      },
    ],
    screenshots: [
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
      "/api/placeholder/300/600",
    ],
  },
  {
    id: "holahome",
    name: "Hola Home",
    tagline: "One-Stop Real Estate Hub",
    description:
      "Seamlessly integrating property booking and listing functionalities. Whether you're hunting for your dream space or showcasing your property, Hola Home streamlines the entire real estate process.",
    downloads: "50+",
    rating: "N/A",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.svangalabs.holahome",
    appStoreUrl: "https://apps.apple.com/in/app/hola-home/id6743438166",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/dp9dkx6n_hola-home.gif",
    heroImage:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/uikg4l9u_hola-home.png",
    techStack: [
      "Flutter",
      "Firebase",
      "Google Maps",
      "Real-time Updates",
      "Provider",
    ],
    problem:
      "Real estate transactions were fragmented across multiple platforms, making property discovery and listing inefficient for both buyers and sellers.",
    solution:
      "Built a unified platform with user-friendly interface for seamless property booking and listing, providing broader audience reach and greater exposure for property listers.",
    impact: [
      "Streamlined real estate transactions",
      "Enhanced property exposure for listers",
      "Simplified booking process for buyers",
    ],
    architecture: {
      overview:
        "Feature-based architecture with real-time updates and location-based services",
      layers: [
        "Presentation Layer (UI)",
        "Business Logic Layer",
        "Data Layer (Firebase)",
        "Maps Integration",
      ],
      scalability:
        "Firebase backend enables horizontal scaling and real-time data synchronization",
      performance:
        "Optimized map rendering and efficient image loading for smooth user experience",
    },
    challenges: [
      {
        title: "Real-time Property Updates",
        description:
          "Ensuring property listings are updated in real-time across all users",
        solution:
          "Implemented Firebase Firestore real-time listeners for instant updates",
      },
      {
        title: "Location-based Search",
        description:
          "Efficiently searching properties based on user location and preferences",
        solution:
          "Integrated Google Maps with geofencing and custom search algorithms",
      },
    ],
    screenshots: ["/api/placeholder/300/600", "/api/placeholder/300/600"],
  },
  {
    id: "sustainability-ledger",
    name: "Sustainability Ledger",
    tagline: "Empowering Sustainable Living",
    description:
      "Australian community resource efficiency platform helping households and businesses track resource usage, identify savings opportunities, and reduce environmental impact.",
    downloads: "50+",
    rating: "N/A",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.sustainabilityledger.app",
    appStoreUrl:
      "https://apps.apple.com/in/app/sustainability-ledger-app/id6497793369",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/yq8um9db_sustainability_ledger.gif",
    heroImage:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/p49pftnh_sustainability.png",
    techStack: [
      "Flutter",
      "Firebase",
      "Real-time Monitoring",
      "Data Analytics",
      "Charts",
    ],
    problem:
      "Households and small businesses lacked tools to effectively track and optimize their resource consumption and environmental impact.",
    solution:
      "Created a comprehensive digital platform with real-time resource monitoring, personalized efficiency insights, and actionable recommendations for sustainable living.",
    impact: [
      "Real-time resource usage tracking",
      "Data-driven sustainability insights",
      "Cost and resource savings for users",
    ],
    architecture: {
      overview:
        "Data-driven architecture with real-time monitoring and analytics",
      layers: [
        "UI Layer",
        "Analytics Engine",
        "Data Processing Layer",
        "Firebase Backend",
      ],
      scalability:
        "Cloud-based infrastructure supporting growing user base and data volume",
      performance:
        "Efficient data aggregation and caching for instant insights",
    },
    challenges: [
      {
        title: "Real-time Data Processing",
        description:
          "Processing and visualizing resource usage data in real-time",
        solution:
          "Implemented efficient data streaming and aggregation with Firebase Cloud Functions",
      },
      {
        title: "Personalized Insights",
        description:
          "Generating meaningful, personalized recommendations for each user",
        solution:
          "Built custom analytics engine with pattern recognition and comparison algorithms",
      },
    ],
    screenshots: ["/api/placeholder/300/600", "/api/placeholder/300/600"],
  },
  {
    id: "forge-trade",
    name: "Forge-Trade",
    tagline: "Real-Time Trading Exchange",
    description:
      "A real-time trading exchange built with Bun, Hono, Redis, and WebSockets. Includes a matching engine, live orderbook, and market maker bot.",
    downloads: "N/A",
    rating: "N/A",
    playStoreUrl: "",
    appStoreUrl: "",
    githubUrl: "https://github.com/Sparsh327/Forge-Trade",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/2m9xov72_Screenshot%202026-03-17%20at%206.07.51%E2%80%AFPM.png",
    heroImage:
      "https://customer-assets.emergentagent.com/job_system-builder-22/artifacts/2m9xov72_Screenshot%202026-03-17%20at%206.07.51%E2%80%AFPM.png",
    techStack: ["Bun", "Hono", "Redis", "WebSockets", "TypeScript"],
    problem:
      "Building a high-performance trading system that can handle thousands of trades per second with low latency.",
    solution:
      "Engineered a real-time matching engine with Redis for order persistence and WebSockets for instant market updates.",
    impact: [
      "Real-time order matching",
      "Live orderbook updates",
      "Market maker bot integration",
    ],
    architecture: {
      overview:
        "Event-driven architecture with real-time order matching and WebSocket communication",
      layers: [
        "WebSocket Server",
        "Matching Engine",
        "Redis Cache",
        "Market Maker Bot",
      ],
      scalability:
        "Horizontal scaling with Redis pub/sub for distributed orderbook",
      performance:
        "Sub-millisecond order matching with in-memory data structures",
    },
    challenges: [
      {
        title: "Order Matching Performance",
        description:
          "Ensuring fast order matching for high-frequency trading scenarios",
        solution:
          "Implemented efficient data structures and algorithms for order prioritization",
      },
      {
        title: "Real-time Updates",
        description:
          "Broadcasting orderbook changes to all connected clients instantly",
        solution:
          "Used WebSocket pub/sub pattern with Redis for efficient message distribution",
      },
    ],
    screenshots: ["/api/placeholder/300/600", "/api/placeholder/300/600"],
  },
];

export const personalProjects = [
  {
    id: "ai-voice-chat",
    name: "AI Voice Chat",
    tagline: "Hands-Free Conversational AI",
    description:
      "An experimental AI assistant with speech-to-text input, intelligent responses, and text-to-speech output for natural voice interactions.",
    downloads: "N/A",
    rating: "N/A",
    playStoreUrl: "",
    appStoreUrl: "",
    githubUrl: "https://github.com/Sparsh327/ai_voice_chat",
    thumbnail:
      "https://images.unsplash.com/photo-1605108222700-0d605d9ebafe?w=400&q=80",
    techStack: ["Flutter", "OpenAI API", "Speech Recognition", "TTS", "BLoC"],
    problem:
      "Exploring seamless audio-based AI interactions for hands-free experiences.",
    solution:
      "Built end-to-end voice pipeline: speech recognition → AI processing → audio playback.",
    impact: [
      "Personal learning project",
      "<2s response latency",
      "Natural conversation flow",
    ],
    architecture: {
      overview: "Pipeline architecture with async audio processing",
      layers: [
        "Audio Input Layer",
        "STT Service",
        "AI Processing",
        "TTS Service",
        "Audio Output",
      ],
      scalability: "Stateless API calls, client-side audio buffering",
      performance: "Streaming audio for lower latency, background processing",
    },
    challenges: [
      {
        title: "Audio Latency",
        description: "Minimizing delay between user speech and AI response",
        solution: "Implemented streaming STT and TTS for faster feedback",
      },
    ],
    screenshots: ["/api/placeholder/300/600", "/api/placeholder/300/600"],
  },
  {
    id: "metube",
    name: "MeTube",
    tagline: "Clean Architecture Learning Project",
    description:
      "A YouTube-style video application demonstrating BLoC pattern with Clean Architecture, SOLID principles, and dependency injection.",
    downloads: "N/A",
    rating: "N/A",
    playStoreUrl: "",
    appStoreUrl: "",
    githubUrl: "https://github.com/Sparsh327/Metube",
    thumbnail:
      "https://images.unsplash.com/photo-1616469829526-7057a1427626?w=400&q=80",
    techStack: [
      "Flutter",
      "BLoC",
      "Clean Architecture",
      "Dependency Injection",
      "YouTube API",
    ],
    problem: "Deepening understanding of scalable architecture patterns.",
    solution:
      "Built production-grade video app with proper separation of concerns and testable codebase.",
    impact: [
      "Architecture learning project",
      "100% test coverage for business logic",
      "Fully modular and testable",
    ],
    architecture: {
      overview: "Clean Architecture with strict layer separation",
      layers: ["Presentation", "Domain", "Data"],
      scalability: "Each layer independently testable and replaceable",
      performance: "Lazy loading, efficient video caching",
    },
    challenges: [
      {
        title: "Implementing SOLID Principles",
        description: "Applying all SOLID principles in real-world app",
        solution:
          "Used interfaces, dependency injection, and single responsibility throughout",
      },
    ],
    screenshots: ["/api/placeholder/300/600", "/api/placeholder/300/600"],
  },
];

export const blogs = [
  {
    id: "1",
    title: "Building Scalable Flutter Apps with Clean Architecture",
    description:
      "A deep dive into implementing clean architecture in production Flutter applications, covering layer separation, dependency injection, and testing strategies.",
    readTime: "8 min",
    publishDate: "2024-03-15",
    mediumUrl: "#",
    tags: ["Flutter", "Clean Architecture", "Mobile Development"],
  },
  {
    id: "2",
    title: "Optimizing Flutter Performance for Large-Scale Apps",
    description:
      "Practical techniques for improving app performance including lazy loading, image optimization, and efficient state management in production environments.",
    readTime: "10 min",
    publishDate: "2024-02-20",
    mediumUrl: "#",
    tags: ["Flutter", "Performance", "Optimization"],
  },
  {
    id: "3",
    title: "Real-Time Communication in Flutter: WebRTC & Socket.IO",
    description:
      "Implementing stable real-time chat and video calling in Flutter apps, handling network variations and scaling for thousands of concurrent users.",
    readTime: "12 min",
    publishDate: "2024-01-10",
    mediumUrl: "#",
    tags: ["Flutter", "WebRTC", "Real-Time"],
  },
];

export const skills = {
  mobile: [
    { name: "Flutter", icon: "Smartphone" },
    { name: "Dart", icon: "Code" },
    { name: "Kotlin", icon: "Coffee" },
    { name: "Jetpack Compose", icon: "Layers" },
    { name: "Swift", icon: "Zap" },
    { name: "Android Native", icon: "Smartphone" },
    { name: "iOS", icon: "Apple" },
  ],
  architecture: [
    { name: "Clean Architecture", icon: "Box" },
    { name: "SOLID Principles", icon: "BookOpen" },
    { name: "Modularization", icon: "Grid3x3" },
    { name: "System Design", icon: "Network" },
    { name: "BLoC Pattern", icon: "GitBranch" },
    { name: "MVVM", icon: "Layers" },
    { name: "Riverpod", icon: "Workflow" },
  ],
  backend: [
    { name: "Firebase", icon: "Flame" },
    { name: "Supabase", icon: "Database" },
    { name: "PostgreSQL", icon: "Database" },
    { name: "REST APIs", icon: "Radio" },
    { name: "WebSockets", icon: "Wifi" },
    { name: "GraphQL", icon: "Network" },
  ],
  devops: [
    { name: "Docker", icon: "Container" },
    { name: "Git", icon: "GitBranch" },
    { name: "CI/CD", icon: "RefreshCw" },
    { name: "Fastlane", icon: "Zap" },
    { name: "Firebase Crashlytics", icon: "AlertCircle" },
    { name: "Sentry", icon: "Shield" },
    { name: "Postman", icon: "Send" },
    { name: "Figma", icon: "Figma" },
  ],
};

export const experience = [
  {
    id: "1",
    company: "AppSynergies",
    role: "Senior Software Developer",
    duration: "July 2023 – Present",
    location: "Remote, UK",
    type: "Full-time",
    impact: [
      "Led delivery of 5+ production Flutter applications with complete ownership",
      "Designed feature-based MVVM architecture improving code readability by 40%",
      "Built CI/CD pipelines cutting release cycles from days to hours",
      "Implemented crash monitoring reducing issue resolution time by 60%",
    ],
    ownership: [
      "End-to-end architecture design and implementation",
      "Technical mentorship for 3 junior developers",
      "Release management and production deployments",
    ],
  },
  {
    id: "2",
    company: "AppSynergies",
    role: "Mobile App Developer",
    duration: "June 2021 – July 2023",
    location: "Remote, UK",
    type: "Full-time",
    impact: [
      "Core contributor to Minglewise (100K+ downloads, 5K+ DAU)",
      "Engineered real-time chat and WebRTC video calling for thousands of concurrent users",
      "Translated complex Figma designs into pixel-perfect responsive UI",
      "Achieved <100ms chat latency through optimized Socket.IO implementation",
    ],
    ownership: [
      "Real-time communication infrastructure",
      "Video calling feature development",
      "UI/UX implementation",
    ],
  },
];
